import { Col, Form, Modal, Row, Select } from 'antd';
import React from 'react';
import jobsService from '../../services/jobs.service';
import { getCandidateTypeFromCode } from '../../utils';
import { TASelect } from '../ta-select';

const { Option } = Select;
const filterOptions = (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

export const SchedualInterviewModal: React.FC<any> = ({
	jobId,
	slotId,
	onSuccess,
	onError,
	candidates,
	onCancel,
	title,
	jobTitle,
	company,
	visible
}) => {
	const [form] = Form.useForm();

	const onFinish = async (values, force = false) => {
		let resp;
		try {
			resp = await jobsService.assignCandidateToInterview(
				jobId,
				slotId,
				values.candidate,
				force,
				getCandidateTypeFromCode(values.candidate.code)
			);
			if (resp === null) throw new Error('Opps, Something went wrong. please contact with support for help.');
		} catch (e: any) {
			if (e.forcable) {
				return Modal.confirm({
					title: `${e.message} Are you sure you want to re-assign this candidate to this job?`,
					okText: 'Force assign',
					onOk: () => onFinish(values, true)
				});
			}
			onError && onError(e);
			console.error(e);
			return;
		}

		onSuccess && (await onSuccess(values.candidate));
		form.resetFields();
	};

	const onFormCancel = () => {
		onCancel && onCancel();
	};

	return (
		<Modal
			title={title || `Assign Candidate for ${jobTitle} at ${company.name}`}
			visible={visible}
			onOk={form.submit}
			onCancel={onFormCancel}
			okText="Assign"
			className="ta ta-modal"
		>
			<Form layout="vertical" className="ta-form" form={form} onFinish={onFinish}>
				<Row gutter={16}>
					<Col xs={{ span: 24 }}>
						<Form.Item
							label={<label className="ta-input-label">Candidate</label>}
							name="candidate"
							rules={[
								{
									required: true,
									message: 'please provide the Candidate name or Email.'
								}
							]}
						>
							<TASelect
								showSearch
								placeholder="type the candidate name or email."
								optionFilterProp="children"
								filterOption={filterOptions}
								style={{ width: '100%' }}
								notFoundContent={<p className="text-center">No available candidates to interview</p>}
							>
								{candidates.map(candidate => (
									<TASelect.Option
										value={candidate.id}
									>{`${candidate.code} | ${candidate.firstName} ${candidate.lastName} | ${candidate.email}`}</TASelect.Option>
								))}
							</TASelect>
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};
